import CrudApi from 'glonass/core/CrudApi'

/**
 * Базовый класс для взаимодействия с корзиной и списком заказов.
 */
export default class OrderApi extends CrudApi {
  /**
   * Создает заказ.
   *
   * @param {{customer: Object}} payload объект (пока только данные покупателя)
   * @return {*} обновленное содержимое корзины
   */
  async createOrder (payload) {
    let {data} = await this.axios.post(this.entry, payload)

    return {
      data: data.data
    }
  }
}



// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/OrderApi.js